import { ConfirmationDialogButtons } from './../base-components/confirmation-dialog/confirmation-dialog-buttons';
import { ParentProperty } from './../base-models/parent-property';
import { Injectable, Injector } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModelData } from '../base-models/model-data';
import { ModalSize } from '../base-models/modal-size';
import { QueryParameter } from '../base-models/query-parameter';
import { ConfirmationDialog } from '../base-components/confirmation-dialog/confirmation-dialog.component';
import { PrintDialog } from '../base-components/print-dialog/print-dialog.component';
import { PromoDialog } from '../base-components/promo-dialog/promo-dialog.component';

@Injectable(
  {
  providedIn: 'root'
}
)

export class ModalService {

  constructor(private injector: Injector) { }
  // constructor(private ngbModalService: NgbModal, private injector: Injector) { }

  count: number = Math.random();

  ShowModal(ID, modelData: ModelData, parentProperty: ParentProperty = null, emitItem: boolean = true, parameters: QueryParameter[] = null){
    var options: NgbModalOptions = {};
    options.injector = this.injector;
    options.backdrop ='static';
    options.keyboard = false;
    options.size = modelData.ModalSize == ModalSize.Lg ? 'lg' : 'sm';
    options.size = modelData.ModalSize as ('lg' | 'sm');
    options.windowClass = 'modal-container';

    const ngbModalService = this.injector.get(NgbModal);
    // const modalRef = this.ngbModalService.open(modelData.UpdateComponent, options);
    const modalRef = ngbModalService.open(modelData.UpdateComponent, options);
    modalRef.componentInstance.modelData = modelData;
    modalRef.componentInstance.ID = ID;
    modalRef.componentInstance.parentProperty = parentProperty;
    modalRef.componentInstance.emitItem = emitItem;
    modalRef.componentInstance.Parameters = parameters;
    
    return modalRef;
  }

  ShowConfirmationDialog(heading: string, message: string, type: string, buttons: ConfirmationDialogButtons = ConfirmationDialogButtons.YesNo){
    var options: NgbModalOptions = {};
    options.injector = this.injector;
    options.backdrop = 'static';
    options.keyboard = false;
    options.size = 'sm';
    options.windowClass = 'modal-confirmation-dialog';

    let modalExists: boolean = this.checkModalStack(ConfirmationDialog, heading);
    //if(modalExists)
      //return;
    const ngbModalService = this.injector.get(NgbModal);
    const modalRef = ngbModalService.open(ConfirmationDialog, options);
    // const modalRef = this.ngbModalService.open(ConfirmationDialog, options);
    modalRef.componentInstance.Heading = heading;
    modalRef.componentInstance.Message = message;
    modalRef.componentInstance.Type = type;
    modalRef.componentInstance.Buttons = buttons;

    return modalRef;
  }

  ShowPrintDialog(
    title: string = ''
    , enablePrintAccountSelection: boolean=false
    , enableAllInOneDoc: boolean = false
    , podvrstaDokumentaStavkaId: number = null
    // , defaultReportHeaderType:string='TextOnly'
  ){
    var options: NgbModalOptions = {};
    options.injector = this.injector;
    options.backdrop = 'static';
    options.keyboard = false;
    options.size = 'md' as ('lg'|'sm');
    options.windowClass = 'modal-print-container';

    const ngbModalService = this.injector.get(NgbModal);

    const modalRef = ngbModalService.open(PrintDialog, options);
    
    modalRef.componentInstance.Title = title;
    modalRef.componentInstance.ShowFirmaZrc=enablePrintAccountSelection;
    modalRef.componentInstance.ShowAllInOneDoc = enableAllInOneDoc;
    modalRef.componentInstance.PodvrstaDokumentaStavkaId = podvrstaDokumentaStavkaId;
    // modalRef.componentInstance.DefaultReportHeaderType=defaultReportHeaderType;

    return modalRef;
  }

  ConvertPluralToSingular(plural: string){
    var singular:string=plural;
    if(plural){
      if (plural.toUpperCase().includes(".PLURAL")){
        singular=plural.substr(0, plural.indexOf("."))+".SINGULAR";
      }
    }

    return singular;
  }

  private checkModalStack(type: any, heading: string){
    const ngbModalService = this.injector.get(NgbModal);
    if(!ngbModalService.hasOpenModals())
    // if (!this.ngbModalService.hasOpenModals())
      return false;

    let exists: boolean = false;

    let modalRefs: any[] = ngbModalService['_modalStack']['_modalRefs'];
    // let modalRefs: any[] = this.ngbModalService['_modalStack']['_modalRefs'];
    modalRefs.forEach((modalRef: NgbModalRef) => {
      if(modalRef.componentInstance instanceof type && modalRef.componentInstance.Heading == heading)
        exists = true;
    })

    return exists;
  }

  ShowPromoDialog(path:string){
    let options: NgbModalOptions = {};
    options.injector = this.injector;
    options.backdrop = 'static';
    options.keyboard = true;
    options.size = 'xl' as ('lg' | 'sm');
    options.windowClass = 'modal-container';

    const ngbModalService = this.injector.get(NgbModal);
    const modalRef = ngbModalService.open(PromoDialog, options);
    // const modalRef = this.ngbModalService.open(PromoDialog, options);
    modalRef.componentInstance.path = path;

    return modalRef;
  }
}
